import { c as _c } from "react/compiler-runtime";
import Spinner from './Spinner';
const CenteredSpinner = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-full w-full grow items-center justify-center"><Spinner /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default CenteredSpinner;